export enum Routes {
  HOME = '/',
  GAMES = 'games',
  CREATE_GAME = 'games/create',
  PLAY_GAME = 'games/play',
  VIEW_GAME = 'games/:id'
}
